var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", [_vm._v("Aktuelle Meldungen")]),
    _vm._v(" "),
    _vm.news.length
      ? _c(
          "div",
          { staticClass: "newsWrapper" },
          _vm._l(_vm.news, function (item, index) {
            return _c("div", { key: item.id, staticClass: "newsCard" }, [
              _c("div", { staticClass: "title" }, [_vm._v(_vm._s(item.title))]),
              _vm._v(" "),
              _c("div", { staticClass: "development" }, [
                _vm._v(_vm._s(item.created.fromNow())),
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "divider",
                staticStyle: { "margin-bottom": "1rem" },
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "description",
                domProps: {
                  innerHTML: _vm._s(
                    item.description.replace(/(?:\r\n|\r|\n)/g, "<br />")
                  ),
                },
              }),
            ])
          }),
          0
        )
      : _c("div", { staticClass: "loaderWrapper" }, [_vm._m(0)]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("i", { staticClass: "fa fa-spin fa-spinner" }),
      _vm._v(" News werden geladen ...\n    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }